export default __webpack_public_path__ + "static/media/4868df91bae516abc876c250cfd1290e.svg";